// src/components/CookieBanner.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext'; // Importation du hook pour accéder à authContext
import AnalyticsWrapper from '../../utils/AnalyticsWrapper';

const CookieBanner = () => {
  const { isLoggedIn } = useAuth(); // Accéder à isLoggedIn depuis authContext
  const [showBanner, setShowBanner] = useState(false);
  const [cookiesAccepted, setCookiesAccepted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      setShowBanner(false);
      setCookiesAccepted(true);
      return;
    }

    const checkVisitorId = async () => {
      try {
        const response = await axios.get('/api/cookie-check', { withCredentials: true });
        if (!response.data.hasVisitorId) {
          setShowBanner(true);
        } else {
          setCookiesAccepted(true); // Cookie already présent, set cookiesAccepted to true
        }
      } catch (error) {
        console.error('Error checking visitorId:', error);
        setShowBanner(true); // Afficher la bannière en cas d'erreur
      }
    };

    checkVisitorId();
  }, [isLoggedIn]);

  const handleAccept = () => {
    setCookiesAccepted(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    setShowBanner(false);
  };

  const handleRedirect = () => {
    navigate('/privacy');
  };

  return (
    <>
    <div
        data-resource="public.cookies"
        data-action="check"
        data-route="/api/cookie-check"
        className="display-none" data-description="Cookies" />
      
      {cookiesAccepted && <AnalyticsWrapper />}
      {showBanner &&
      <div className="cookie-banner">
          <p className="cookie-message">
            We use analytic cookies to improve your user experience. No personal data is stored or shared with any third parties. For more information, see our
            <button onClick={handleRedirect} className="cookie-link">privacy policy</button>.
          </p>
          <button onClick={handleAccept} className="cookie-button accept-button">Accept</button>
          <button onClick={handleDecline} className="cookie-button decline-button">Decline</button>
        </div>
      }
    </>);

};

export default CookieBanner;